import React from "react";

export type RuleBlockVariant = "card" | "plain";

interface RuleBlockCardProps {
  icon: React.ReactNode;
  /** 아이콘 배경 색상 클래스 (예: "bg-[#E7EFFF]") */
  iconBgClassName: string;
  title: string;
  description: React.ReactNode;
  /** "card": 흰색 카드 래퍼 포함(페이지용), "plain": 래퍼 없음(팝업용) */
  variant?: RuleBlockVariant;
  children: React.ReactNode;
}

/**
 * 주문 인식 규칙의 각 블럭(등록된 고객 메일 / 주문 키워드 / 처리한 메일)이
 * 공유하는 헤더 + 카드 래퍼. 페이지(카드)와 팝업(plain) 양쪽에서 재사용한다.
 */
const RuleBlockCard: React.FC<RuleBlockCardProps> = ({
  icon,
  iconBgClassName,
  title,
  description,
  variant = "card",
  children,
}) => {
  return (
    <div
      className={
        variant === "card"
          ? "bg-white border border-[#e0e0e0] rounded-[12px] p-5"
          : ""
      }
    >
      <div className="mb-5 flex flex-row items-start gap-3">
        <div
          className={`aspect-square p-2 ${iconBgClassName} rounded-[0.5rem]`}
        >
          {icon}
        </div>
        <div className="flex flex-col items-start text-start">
          <h2 className="text-[16px] font-bold">{title}</h2>
          <span className="text-[13px] break-keep">{description}</span>
        </div>
      </div>
      {children}
    </div>
  );
};

export default RuleBlockCard;
